module.exports = __webpack_public_path__ + "static/media/mapeala-contacto.25e2cffe.jpg";